import { Text } from "@chakra-ui/react"
import { format } from "date-fns"
import { TZDate, tzName } from "@date-fns/tz"
import { useTimezone } from "providers/timezone"
import zones from "config/timezones"

export default function FormattedTimeString({ event, config = {}, styles = {} }) {
    const { timezone } = useTimezone()
    let tzString

    const defaults = {
        timeFormat: "h:mm a", // default format for local timezones that are not listed in our zones config
        showEndTime: false,
        showTimezone: false,
    }

    const settings = { ...defaults, ...config }

    const configuredTimezone = zones.find(zone => zone.name === timezone)

    const timeFormat = config.timeFormat || configuredTimezone?.format || defaults.timeFormat

    let str = format(new TZDate(new Date(event.datetime_start), timezone), timeFormat)

    if (settings.showEndTime) {
        str += " — " + format(new TZDate(new Date(event.datetime_end), timezone), timeFormat)
    }

    if (settings.showTimezone) {
        tzString = tzName(timezone, new Date(event.datetime_start), "short")
        str += " " + tzString
    }

    if (str === "MST" || tzString === "MST") {
        str += "/PDT"
    }

    // Set am/pm and timezone as small text.
    const re = new RegExp("([A-Z/ ]{2,8})", "g")
    str = str.replace(re, '<small class="agendaTime__unit">$1</small>')

    return <Text as="span" dangerouslySetInnerHTML={{ __html: str }} {...styles} />
}
